<div class="ui grid segment backgroundcolor zeroPaddingMargin" [ngStyle]="styles.main">
  <div class="ui column zeroPaddingMargin" [ngStyle]="styles.fixtureArea">
    <div class="ui grid segment zeroPaddingMargin" style="height:100%">
      <div class="ui sixteen wide column" [ngStyle]="styles.header">



        <DropdownMenu [_DATA]="categoryData" [componentWidth]="250" [selectDataKey]="'EnumSportType'"
          [isTranslated]=false [dropdownType]="'sportCategory'" [isBig]=true
          (selectedItem)="sportChangeHandler($event.key)">
        </DropdownMenu>
        <DropdownMenu [dropdownType]="'leagueCategory'" [_DATA]="leagueData" [componentWidth]="270"
          [selectDataKey]="'EnumSportType'" [tournamentSportEventCount]="'tournamentSportEventCount'"
          [displayNameKey]="'name'" [sportEventCount]="'sportEventCount'" [altNameKey]="'alt'" [rowNumber]=3
          [isBig]=true (selectedItem)="tournamentSelectHandler($event.key,$event.item)" [isTranslated]=false>
        </DropdownMenu>
      </div>
      <div class="ui sixteen wide column ScrollBar ScrollMarPad" id="scrollableContainer" [ngStyle]="styles.rows"
        style="scroll-behavior: smooth;">
        <outrightsFixture [dataArray]="this.OddsData"></outrightsFixture>

      </div>
      <div class="ui sixteen wide column" [ngStyle]="styles.footer">
        <comp_livebetfooter></comp_livebetfooter>
      </div>
    </div>
  </div>
  <div class="ui column" [ngStyle]="styles.bettingSlip">
    <bettingSlip></bettingSlip>
  </div>
</div>
